import { useLocation, useNavigate } from 'react-router';
import { useMenus } from '@/providers';
import { useMenuCurrentItem, KeenIcon } from '@/components';
import { ToolbarBreadcrumbs } from '.';
import { getBasePath } from '@/utils/env';
import { CircleArrowLeft } from 'lucide-react';

const ToolbarHeading = ({
  title = ''
}) => {
  const {
    getMenuConfig
  } = useMenus();
  const {
    pathname
  } = useLocation();
  const navigate = useNavigate();
  const currentMenuItem = useMenuCurrentItem(pathname, getMenuConfig('primary'));
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;
  const base = getBasePath();
  const normalizePath = (value) => {
    const raw = value || '/';
    const stripped = raw.replace(/\/+$/, '');
    return stripped === '' ? '/' : stripped;
  };
  const isAtBase = normalizePath(window.location.pathname) === normalizePath(base);
  const goBackBtnHiddenPaths = ['/company-billing/license', '/company/list']

  return <div className="flex flex-col justify-center items-start flex-wrap gap-1 lg:gap-2">
    {canGoBack && !isAtBase && !goBackBtnHiddenPaths.includes(pathname) &&
      // <button type="button" className="group badge badge-outline badge-lg text-xl badge-primary text-[10px]" onClick={() => navigate(-1)}>
      //   <KeenIcon icon="left" className='text-xs' />
      //   Back
      // </button>
      <button
        type="button"
        className="btn btn-sm btn-primary btn-outline"
        onClick={() => navigate(-1)}
      >
        <CircleArrowLeft className="size-4" />
        Back
      </button>
    }
    <h1 className="font-medium text-lg text-gray-900">{title || currentMenuItem?.title}</h1>
    {/* <div className='flex items-center gap-2'>
    </div> */}
    <div className="flex items-center gap-2 text-sm font-normal">
      <ToolbarBreadcrumbs />
    </div>
  </div>;
};
export { ToolbarHeading };
